module.exports = __webpack_public_path__ + "img/google-play.3d14c3d5.png";